module.exports = __webpack_public_path__ + "img/hydraulics_video_splash.51a40c84.jpg";